import { parentRequestModalActionTypes } from './Constants';

export function toggleParentRequestModal(open) {
	return {
		type: parentRequestModalActionTypes.TOGGLE_PARENT_REQUEST_MODAL,
		payload: {
			open,
		},
	};
}

export function handleParentRequestModal(packages, selectedId) {
	return {
		type: parentRequestModalActionTypes.HANDLE_PARENT_REQUEST_MODAL,
		payload: {
			packages,
			selectedId,
		},
	};
}

export function setPackageName(data) {
	return {
		type: parentRequestModalActionTypes.SET_PACKAGE_NAME,
		payload: {
			data,
		},
	};
}

export function getAvailablePackagesRequest(type) {
	return {
		type: parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_REQUEST,
		payload: {
			type,
		},
	};
}

export function getAvailablePackagesSuccess(data) {
	return {
		type: parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getAvailablePackagesError(error) {
	return {
		type: parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_ERROR,
		payload: {
			error,
		},
	};
}

export function parentPaymentRequest(modalData) {
	return {
		type: parentRequestModalActionTypes.PARENT_PAYMENT_REQUEST,
		payload: {
			modalData,
		},
	};
}

export function parentPaymentSuccess() {
	return {
		type: parentRequestModalActionTypes.PARENT_PAYMENT_SUCCESS,
	};
}

export function parentPaymentError(error) {
	return {
		type: parentRequestModalActionTypes.PARENT_PAYMENT_ERROR,
		payload: {
			error,
		},
	};
}

export function whatsAppShareRequest(planId) {
	return {
		type: parentRequestModalActionTypes.WHATSAPP_SHARE_REQUEST,
		payload: {
			planId,
		},
	};
}

export function whatsAppShareError(error) {
	return {
		type: parentRequestModalActionTypes.WHATSAPP_SHARE_ERROR,
		payload: {
			error,
		},
	};
}
